import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';
import { articles } from '@/mocks/articles';

export default function BrandFocus() {
  const flagship = films[0];
  const latest = articles.filter((a) => a.topicId === 'topic-1').slice(0, 3);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
        <div className="lg:col-span-2">
          <div className="flex flex-col gap-2 mb-6">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-3">
              <span className="w-1.5 h-6 rounded-full bg-accent-500" />
              品牌焦点 ·《姐姐的朋友》
            </h2>
            <p className="text-sm text-foreground-500 pl-4">围绕《姐姐的朋友》最新剧情与相关资讯</p>
          </div>

          <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100">
            <div className="relative w-full h-56 md:h-72 overflow-hidden bg-background-200">
              <img
                src={flagship.backdrop}
                alt={`${flagship.title} 剧照`}
                title={`${flagship.title} 剧情介绍`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-semibold mb-2">
                  <i className="ri-movie-2-line" />
                  {flagship.type === 'movie' ? '电影' : '电视剧'} · {flagship.year}
                </span>
                <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50">
                  {flagship.title}
                </h3>
              </div>
            </div>
            <div className="p-5 md:p-6">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{flagship.synopsis}</p>
              <div className="flex flex-wrap items-center gap-3">
                <span className="flex items-center gap-1 text-sm font-semibold text-accent-600">
                  <i className="ri-star-fill" />
                  {flagship.rating.toFixed(1)}
                </span>
                <span className="text-sm text-foreground-500">导演 {flagship.director}</span>
                <span className="text-sm text-foreground-500">{flagship.duration}</span>
                <Link
                  to={`/detail/${flagship.id}`}
                  className="ml-auto flex items-center gap-1 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看完整剧情
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-3">
              <span className="w-1.5 h-5 rounded-full bg-accent-500" />
              最新资讯
            </h2>
            <Link
              to="/topic/topic-1"
              className="text-xs font-medium text-primary-700 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              更多
            </Link>
          </div>
          <div className="flex flex-col gap-3">
            {latest.map((article) => (
              <Link
                key={article.id}
                to={`/topic/${article.topicId}`}
                className="group flex gap-4 p-3 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="w-20 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={article.cover}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-between min-w-0 py-1">
                  <h3 className="font-medium text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {article.title}
                  </h3>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.date}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}